
const initState = {
  obj: {},
  list: [],
  num: 0,
  string: ''
}

function rootreduce(state, action) {
  // console.log(action, 111)
  return initState
}

export default rootreduce